import CardService from '../../shared/services/card-service';

export default {
    methods: {
        moreThanOneCards: function (cards) {
            var self = this;
            CardService.getSavedCards(cards).then((res) => {
                if (res && res.data) {
                    self.cards = res.data;
                }
                else {
                    console.log("CARDS DOES NOT EXIST, SO ADD IT TO THE ADMIN");
                }
            });
        },
        addCardToCompare: function(cardData) {
            // Check if limit is reached
            if (this.cards.length >= 4) {
                console.log('Maximum card limit reached');
                return;
            }

            // Add card to comparison
            this.cards.push(cardData);
            localStorage.setItem('cardItems', JSON.stringify(this.cards));
        }
    }
};